import { Component, OnInit } from '@angular/core';
import { OappService } from '../../services/oapp.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(public oappService: OappService) { }

  ngOnInit(

  ) {console.log('oappService',this.oappService); }

}
